export const lawyer = {
    YoonYounghwan: {
        title: "윤영환",
        titleEn: "Yoon Younghwan",
        info: [
            {
                title: "약력",
                infoDetail: [
                    {
                        txt: "법무법인 태성 대표변호사",
                        bold: true,
                    },
                    "고려대학교 졸업 (건설 공학 전공)",
                    {
                        txt: "건축시공기술사",
                        bold: true,
                    },
                    "토목기사",
                    "대한변호사협회 건설전문변호사",
                    "대한변호사협회 재개발·재건축전문변호사",
                    "전) 국회 하자 정책토론위원",
                    "전) 한국건설기술연구원 시민감사관",
                    "전) 건설이코노미뉴스 칼럼니스트 ",
                    "네이버 지식iN 건설 전문가 상담 위원",
                    "공동주택하자소송 400여 건 담당",
                    "MBC 등 언론사 법률자문 제공",
                    "대한주택관리사협회 경기도회 강의",
                    "대한주택관리사협회 광주시회 강의",
                    //
                ],
            },
        ],
        ceo: true,
        representative: true,
    },

    KooChanhoe: {
        title: "구찬회",
        titleEn: "Koo Chanhoe",
        comment: "<span class='primary--text'>정비사업·건설사업에 관한 깊은 이해</span>를 바탕으로 언제나 신속하고 실질적인 해결책을 제시하겠습니다.",
        info: [
            {
                title: "약력",
                infoDetail: [
                    "정비사업팀 팀장 변호사",
                    "대한변호사협회 재개발·재건축 전문 변호사",
                    "대한변호사협회 건설 전문 변호사",
                    "정비사업 담당 변호사",
                    "아파트 하자 소송 담당 변호사",
                    "입주예정자협의회 담당 변호사",
                    "현) 한국주택경제 칼럼니스트",
                    //
                ],
            },
            {
                title: "주요 업무 수행사례",
                infoDetail: [
                    "부산·경남 소재 정비사업조합, 시공사 해지 관련 가처분 ",
                    "부산·경남 소재 정비사업조합, 총회효력정지가처분",
                    "부산·경남 소재 정비사업조합, 총회/대의원회 개최금지가처분",
                    "조합 임원 직무집행정지가처분",
                    "시공자·수급인지위확인 소송",
                    "관리처분계획 취소·무효 소송",
                    "총회결의무효확인 소송",
                    "정비사업 관련 공사대금, 용역대금, 손해배상 소송",
                    "도시정비법위반죄 등 정비사업 관련 조합 임원 형사사건, 수사단계 종결",
                    "집합건물법상 관리단 분쟁 가처분 및 소송",
                    //
                ],
            },
        ],
    },

    JungWoojoong: {
        title: "정우중",
        titleEn: "Jung Woojoong",
        info: [
            {
                title: "약력",
                infoDetail: [
                    "대한변호사협회 등록 건설전문변호사",
                    "전남개발공사 계약심의위원",
                    "광주, 전북 연구개발 특구진흥재단 자문",
                    "광주지방경찰청 인권위원",
                    "광주광역시 행정심판위원, 공유재산심의위원",
                    "전남대학교 법과대학, 법학전문대학원 졸업",
                    //
                ],
            },
        ],
    },

    LimJunghoon: {
        title: "임정훈",
        titleEn: "Lim Junghoon",
        info: [
            {
                title: "약력",
                infoDetail: [
                    "대한변호사협회 등록 건설전문변호사",
                    "대한변호사협회 등록 금융전문변호사",
                    "광주은행 자문변호사",
                    "한국자산관리공사 자문변호사",
                    "광주광역시 공기관 자문변호사",
                    "광주광역시 환경관리공단 이사",
                    "광주지방법원 법인파산관재인",
                    "전) 변호사 노로·임정훈 법률사무소",
                    "전) 한국자산관리공사 근무",
                    //
                ],
            },
        ],
    },

    NamDeokho: {
        title: "남덕호",
        titleEn: "Nam Deokho",
        info: [
            {
                title: "약력",
                infoDetail: [
                    "아파트하자소송 담당 변호사",
                    "입주예정자협의회 법률 지원 변호사",
                    "연세대학교 법학전문대학원",
                    "인천지방법원 실무 수습",
                    "정부법무공단 실무 수습",
                    //
                ],
            },
        ],
    },

    ChoiYuna: {
        title: "최유나",
        titleEn: "Choi Yuna",
        info: [
            {
                title: "약력",
                infoDetail: [
                    {
                        txt: "법무법인 태성 대표변호사",
                        bold: true,
                    },
                    "아파트생활법률상담변호사",
                    "한국심리학회 자문 변호사",
                    "SBS 법정드라마 ‘굿파트너‘ 집필",
                    "법률인스타툰 <메리지레드> 연재",
                    "베스트셀러 <혼자와 함께 사이>, <우리 이만 헤어져요> 집필",
                    "tvN ‘유퀴즈 온더 블록‘ 이혼전문변호사로 출연",
                    "CBS ‘세상을 바꾸는 시간 15분’ 강연 200만 뷰 달성",
                    "SBS ‘돌싱포맨’, KBS ‘아침마당’ 등 다수 방송 출연",
                    "前 네이버 연애결혼, 법률판 자문",
                    "前 매일경제 칼럼리스트",
                    "그 외 CBS ‘시사자키’, 언론사 ‘주간동아’, ‘여성동아’, ‘한국일보’, ‘조선일보’ 인터뷰 진행",
                    //
                ],
            },
        ],
        ceo: true,
    },

    MoonJongha: {
        title: "문종하",
        titleEn: "Moon Jongha",
        info: [
            {
                title: "약력",
                infoDetail: [
                    "대한변호사협회 건설전문변호사",
                    "건설이코노미뉴스 칼럼니스트",
                    "행정심판 법률지원 변호사",
                    "중소기업 법률자문단",
                    "아파트 법률문제 자문 변호사",
                    "아파트 하자보수 소송 수행",
                    "디자인회사 등 자문 변호사",
                    "전) 법무법인 서우",
                    //
                ],
            },
        ],
    },

    LeeJunhee: {
        title: "이준희",
        titleEn: "Lee Junhee",
        info: [
            {
                title: "약력",
                infoDetail: [
                    "대한변호사협회 건설전문변호사",
                    "아파트하자소송 법률지원 변호사",
                    "아파트 법률지원 변호사",
                    "제47회 세무사 시험 합격",
                    "서울시립대학교 법학전문대학원 졸업",
                    "전) 법무법인 청조 실무 수습",
                    "전) 법무법인 선한",
                    //
                ],
            },
        ],
    },

    KimTaeeun: {
        title: "김태은",
        titleEn: "Kim Taeeun",
        info: [
            {
                title: "약력",
                infoDetail: [
                    "대한변호사협회 건설전문변호사",
                    "아파트하자소송 법률지원 변호사",
                    "입주예정자협의회 법률지원 변호사",
                    "아파트 법률문제 자문 변호사",
                    "전) 법무법인 운율 소속 변호사",
                    //
                ],
            },
        ],
    },

    WonHyewon: {
        title: "원혜원",
        titleEn: "Won Hyewon",
        info: [
            {
                title: "약력",
                infoDetail: [
                    "대한변호사협회 건설전문변호사",
                    "정비사업 담당 변호사",
                    "아파트하자소송 담당 변호사",
                    "부산대학교 법학전문대학원 졸업",
                    "전) 법무법인 영동 변호사",
                    "전) 법무법인 올흔 자문 변호사",
                    //
                ],
            },
        ],
    },

    ChungJieun: {
        title: "정지은",
        titleEn: "Chung Jieun",
        info: [
            {
                title: "약력",
                infoDetail: [
                    "아파트하자소송 담당 변호사",
                    "입주예정자협의회 법률 지원 변호사",
                    "아파트 법률 문제 자문 변호사",
                    "고려대학교 자유전공학부 정치외교학과 졸업",
                    "서울동부지방검찰청 실무수습",
                    //
                ],
            },
        ],
    },

    BaeJiwon: {
        title: "배지원",
        titleEn: "Bae Jiwon",
        info: [
            {
                title: "약력",
                infoDetail: [
                    "서울대 졸업",
                    "사법시험 제43회(사법연수원 33기)",
                    "법무법인 태성 공증 변호사",
                    "인천자유구역청 토지개발 관련 소송 ",
                    "목동 하이페리온 하자 관련 소송 ",
                    "가든파이브 상가 집단 분쟁 소송",
                    "가락농수산물시장 시설현대화 사업 관련 상가(청과도매조합) 자문 및 소송",
                    "재개발.재건축 자문 및 소송",
                    "전) 강남구청 무료 상담 변호사",
                    "전) (주)엠포스 고문 변호사",
                    "전) (주)빌리어즈TV 고문 변호사",
                    "전) (주)엠피아 고문 변호사",
                    "전) (주)골프넷 고문 변호사",
                    "전) (주)웨인테크놀로지 고문 변호사",
                    "전) (주)대산 고문 변호사",
                    "전) (주)시소캐피탈 고문 변호사",
                    //
                ],
            },
        ],
    },

    KimYeongjae: {
        title: "김영재",
        titleEn: "Kim Yeongjae",
        info: [
            {
                title: "약력",
                infoDetail: [
                    "아파트하자소송 담당 변호사",
                    "입주예정자협의회 법률 지원 변호사",
                    "경희대학교 법학전문대학원 졸업",
                    "전) 울산지방법원 재판연구원",
                    "전) 부산고등법원 재판연구원",
                    "전) 서울지방국세청 송무국",
                    "전) 법무법인 홉스앤킴 소속 변호사",
                    //
                ],
            },
        ],
    },

    LeeJihye: {
        title: "이지혜",
        titleEn: "Lee Jihye",
        info: [
            {
                title: "약력",
                infoDetail: [
                    "연세대학교 졸업",
                    "제49회 사법시험 합격 (사법연수원 39기)",
                    "제50회 사법시험 검토위원",
                    "아파트하자소송 담당 변호사",
                    "입주예정자협의회 법률 지원 변호사",
                    "법무법인 태성 공증 변호사",
                    "전) 서울남부지방검찰청 검사",
                    "전) 수원지방검찰청 평택지청 검사",
                    "전) 대구지방검찰청 검사",
                    "전) 대검찰청 검찰연구관",
                    "전) 의정부지방검찰청 검사",
                    "전) 2024 미국 캘리포니아주 샌디에고대 로스쿨 방문학자(다양한 양태의 성범죄에 대한 미국의 대응체계 연구논문)",
                    "전) 대검찰청 우수수사사례 선정 다수",
                    "전) 2017 통합사무감사 수범직원 선정",
                    "전) 2025 전국성폭력상담소협의회 시민감시단 선정 성폭력 수사·재판 과정에서의 인권보장을 위한 디딤돌상 수상",
                    //
                ],
            },
        ],
    },

    KimJihyun: {
        title: "김지현",
        titleEn: "Kim Jihyun",
        info: [
            {
                title: "약력",
                infoDetail: [
                    "정비사업 담당 변호사",
                    "서울대 경제학부 최우등졸업",
                    "고려대 법학전문대학원 우등졸업",
                    "대법원 국선변호인",
                    "경기제2지역 군사법원 국선변호인",
                    "수원가정법원 국선보조인",
                    "경기도 법률상담위원",
                    "전) 법무법인 케이씨엘",
                    "전) 법률사무소 민앤정",
                    //
                ],
            },
        ],
    },

    KwonGiwook: {
        title: "권기욱",
        titleEn: "Kwon Giwook",
        info: [
            {
                title: "약력",
                infoDetail: [
                    "정비사업 담당 변호사",
                    "입주예정자협의회 법률 지원 변호사",
                    "경희대학교 원자력공학과 졸업",
                    "한양대학교 법학전문대학원 졸업",
                    "서울중앙지방법원 실무수습",
                    "전) 법무법인 와이케이",
                    //
                ],
            },
        ],
    },


    ParkKyuhoon: {
        title: "박규훈",
        titleEn: "Park Kyuhoon",
        info: [
            {
                title: "약력",
                infoDetail: [
                    "대한변호사협회 건설전문변호사",
                    "대한변호사협회 재개발, 재건축전문변호사",
                    "아파트하자소송 변호사",
                    "건설이코노미뉴스 칼럼니스트",
                    "전) 팜팩토리 법률 자문 변호사",
                    "전) 예그리나 법률 자문 변호사",
                    "인하대학교 법학과 졸업",
                    "전북대학교 법학전문대학원 졸업",
                    "사법연수원 하계연수",
                    //
                ],
            },
        ],
    },

    LeeJihyeon: {
        title: "이지현",
        titleEn: "Lee Jihyeon",
        info: [
            {
                title: "약력",
                infoDetail: [
                    "아파트하자소송 담당 변호사",
                    "이화여자대학교 소비자학과 수석졸업",
                    "경북대학교 법학전문대학원 졸업",
                    "서울남부지방법원 실무수습",
                    "전) 법무법인 아크로",
                    //
                ],
            },
        ],
    },
};
